import { AnalyticsField, ScreenResourceEvent } from '@bighealth/analytics';
import { fire_ui_events } from '@bighealth/api/Event/v1';

import { getAnalyticsDate } from './getAnalyticsDate';
import { getUserAgent } from './getUserAgent';
import { URLLike } from './useGetURL';

export const sendScreenViewedAnalytics = async ({
  field,
  productId,
  programId,
  sceneSetGraphId,
  url,
  productVersionStream,
}: {
  field: AnalyticsField;
  productId: number;
  programId: number;
  sceneSetGraphId: number;
  url: URLLike;
  productVersionStream?: string;
}): Promise<void> => {
  const userAgent = await getUserAgent();
  const clientAppNodePackageVersion = require('../../../../package.json')
    .version;
  const payload: ScreenResourceEvent = {
    occurred_at: getAnalyticsDate(),
    product_id: productId,
    program_id: programId,
    action: 'viewed',
    name: `screen|viewed|${field?.area}`,
    resource: 'screen',
    type: 'ui',
    body: {
      fields: {
        feature: field,
        route: url.pathname,
      },
      meta: {
        http: {
          current_url: url.href,
          referrer: url.href,
          user_agent: userAgent,
          client_app_node_package_version: clientAppNodePackageVersion,
          product_stream_version: productVersionStream,
        },
      },
      relations: {
        scene_set_graph: {
          id: sceneSetGraphId,
        },
      },
    },
  };

  try {
    // Do not await this. We do not care if it succeeds or fails and we do not want
    // to block the thread for this API call
    fire_ui_events({
      events: [payload],
    });
  } catch (error) {
    console.error('Attempted to send analytics but failed', payload);
  }
};
